'use strict';

module.exports = {
  NotSupportedError: require('./NotSupportedError')
};


//////////////////
// WEBPACK FOOTER
// ./~/@trust/jwa/lib/errors/index.js
// module id = 34
// module chunks = 0